<template>
  <section
    :class="['h2h-set', { 'h2h-set--mobile': isLayoutMobile }]"
    :data-h2h-set="settings.regionUUID"
  >
    <div class="h2h-set__toolbar" v-if="(showTagFilters && tags.length) || showNavigation">
      <div
        v-if="showTagFilters && tags.length"
        class="h2h-set__filters"
        role="group"
        aria-label="Filter races"
      >
        <button type="button" :aria-pressed="selectedTag === null" @click="selectedTag = null">
          All
        </button>
        <button
          v-for="tag in tags"
          :key="tag"
          type="button"
          :aria-pressed="selectedTag === tag"
          @click="selectedTag = tag"
        >
          {{ tag }}
        </button>
      </div>
      <div
        v-if="reserveNavigation"
        class="h2h-set__navigation"
        :class="{ 'h2h-set__navigation--hidden': !showNavigation }"
        :aria-hidden="!showNavigation"
        aria-label="Race navigation"
      >
        <button type="button" aria-label="Previous race" :disabled="atStart" @click="moveSlide(-1)">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5m6-6-6 6 6 6" /></svg>
        </button>
        <button type="button" aria-label="Next race" :disabled="atEnd" @click="moveSlide(1)">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
        </button>
      </div>
    </div>
    <p v-if="tiles.length && !visibleTiles.length" class="h2h-set__empty" role="status">
      No races match this tag
    </p>
    <swiper
      v-else-if="isScroll && visibleTiles.length"
      class="h2h-set__carousel"
      :modules="swiperModules"
      slides-per-view="auto"
      :space-between="16"
      :keyboard="{ enabled: true, onlyInViewport: true }"
      :nested="true"
      :mousewheel="{ forceToAxis: true, releaseOnEdges: true }"
      :watch-overflow="true"
      @swiper="onSwiper"
      @slide-change="syncNavigation"
      @resize="syncNavigation"
      @lock="syncNavigation"
      @unlock="syncNavigation"
      @reach-beginning="syncNavigation"
      @reach-end="syncNavigation"
      @from-edge="syncNavigation"
    >
      <swiper-slide
        v-for="tile in visibleTiles"
        :key="tile.tileUUID"
        :data-tile-uuid="tile.tileUUID"
      >
        <component :is="tileComponent" :settings="tile" :chart-records="records(tile)" />
      </swiper-slide>
    </swiper>
    <div v-else-if="visibleTiles.length" class="h2h-set__grid">
      <div
        v-for="tile in visibleTiles"
        :key="tile.tileUUID"
        class="h2h-set__tile"
        :data-tile-uuid="tile.tileUUID"
      >
        <component :is="tileComponent" :settings="tile" :chart-records="records(tile)" />
      </div>
    </div>
  </section>
</template>
<script src="./h2h-market-tile-set.js"></script>
<style src="./h2h-market-tile-set.scss" lang="scss"></style>
